export const FORM_ID = 'group-form';
export const GROUP_NAME_MAX_LENGTH = 35;
export const GROUP_DESCRIPTION_MAX_LENGTH = 400;
